import React, { useState } from 'react';
import { ThemeProvider } from '@mui/material';
import { themeCreator } from './base';
import { StylesProvider } from '@mui/styles';
// import { CacheProvider } from '@emotion/react';
// import createCache from '@emotion/cache';
// import stylisRTLPlugin from 'stylis-plugin-rtl';

// const cacheRtl = createCache({
//   key: 'bloom-ui',
// prepend: true,
//
//   stylisPlugins: [stylisRTLPlugin]
// });

// Define a constant version
const APP_VERSION = "v1.1.5e";

export const ThemeContext = React.createContext();

const ThemeProviderWrapper = function (props) {
  // Fetch theme from localStorage or default to 'NebulaFighterTheme'
  const curThemeName = localStorage.getItem('appTheme') || 'NebulaFighterTheme';
  const [themeName, _setThemeName] = useState(curThemeName);
  
  // Create theme using themeName
  const theme = themeCreator(themeName);
  
  // Function to update the theme and store in localStorage
  const setThemeName = (newThemeName) => {
    localStorage.setItem('appTheme', newThemeName);
    _setThemeName(newThemeName);
  };

  return (
    <StylesProvider injectFirst>
      {/* <CacheProvider value={cacheRtl}> */}
      {/* Provide themeName, setThemeName, and the app version in the context */}
      <ThemeContext.Provider value={{ themeName, setThemeName, version: APP_VERSION }}>
        <ThemeProvider theme={theme}>
          {props.children}
        </ThemeProvider>
      </ThemeContext.Provider>
      {/* </CacheProvider> */}
    </StylesProvider>
  );
};

export default ThemeProviderWrapper;
